import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import RemoveIcon from '@mui/icons-material/Remove';
import IconButton from '@mui/material/IconButton';
import Icon from 'common/components/Elements/Icon/Icon';
import theme from 'core/utilities/theme';
import I18n from 'i18n/en-US';
import React from 'react';

type ButtonIconStyle = 'dots' | 'arrows';

interface ButtonComponentProps {
  buttonIconStyle?: ButtonIconStyle;
  setShowAll: (value: boolean) => void;
}

function ExpandButton({ buttonIconStyle, setShowAll }: ButtonComponentProps) {
  return (
    <IconButton
      onClick={() => setShowAll(true)}
      size="small"
      title={I18n.Elements.ExpandableText.expand}
      sx={{ p: theme.spacing(0, 1) }}
      data-e2e-text-expand=""
    >
      <Icon element={buttonIconStyle === 'arrows' ? KeyboardDoubleArrowDownIcon : MoreHorizIcon} />
    </IconButton>
  );
}

function CollapseButton({ buttonIconStyle, setShowAll }: ButtonComponentProps) {
  return (
    <IconButton
      onClick={() => setShowAll(false)}
      size="small"
      title={I18n.Elements.ExpandableText.collapse}
      sx={{ p: theme.spacing(0, 1) }}
      data-e2e-text-collapse=""
    >
      <Icon element={buttonIconStyle === 'arrows' ? KeyboardDoubleArrowUpIcon : RemoveIcon} />
    </IconButton>
  );
}

export interface ComponentProps {
  text?: string;
  maxLength: number;
  renderer?: (text: string, button: JSX.Element | null) => JSX.Element;
  buttonIconStyle?: ButtonIconStyle;
}

function ExpandableText({
  text, maxLength, renderer, buttonIconStyle,
}: ComponentProps) {
  const [showAll, setShowAll] = React.useState(false);

  if (!text) return null;

  if (text.length > maxLength && !showAll) {
    return renderer
      ? renderer(text.slice(0, maxLength), <ExpandButton setShowAll={setShowAll} buttonIconStyle={buttonIconStyle} />)
      : (
        <>
          {text.slice(0, maxLength)}
          <ExpandButton setShowAll={setShowAll} buttonIconStyle={buttonIconStyle} />
        </>
      );
  }

  return renderer
     
    ? renderer(text, text.length > maxLength ? <CollapseButton setShowAll={setShowAll} buttonIconStyle={buttonIconStyle} /> : null)
    : (
      <>
        {text}
        {text.length > maxLength && <CollapseButton setShowAll={setShowAll} buttonIconStyle={buttonIconStyle} />}
      </>
    );
}

export default ExpandableText;
